export default {
  // Common
  'common.cancel': '取消',
  'common.ok': '确定',
  
  'pages.layouts.userLayout.title': 'CRM客户关系管理系统',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  // Dashboard translations
  'pages.dashboard.text': '无缝接入门店管理生态，提供远程积分管理解决方案。',
  'pages.dashboard.headquartersManagement': '总部管理',
  'pages.dashboard.orders': '发票',
  'pages.dashboard.members': '会员',
  'pages.dashboard.cards': '礼品卡',
  'pages.dashboard.coupons': '折扣券',
  'pages.dashboard.management.title': '总部管理',
  // Card tooltips
  'pages.dashboard.tooltip.orders': '发票列表',
  'pages.dashboard.tooltip.members': '会员列表',
  'pages.dashboard.tooltip.cards': '礼品卡管理',
  'pages.dashboard.tooltip.coupons': '折扣券管理',
  'pages.dashboard.store.online': '已营业',
  'pages.dashboard.store.offline': '未营业',
  'pages.dashboard.store.points': '积分',
  'pages.dashboard.store.cardValue': '卡值',
  'pages.dashboard.headquartersVoucher': '总部代金券',
  'pages.dashboard.headquartersVoucher.title': '创建总部代金券',
  'pages.dashboard.tooltip.qrcode': '显示会员注册二维码',
  'pages.dashboard.qrcode.title': '会员注册二维码',
  'pages.dashboard.qrcode.download': '下载二维码',
  'pages.dashboard.qrcode.close': '关闭',
  // Order list translations
  'pages.store.title': '首页',

  'pages.invoiceList.title': '发票列表',
  'pages.invoiceList.search.invoiceNumber.placeholder': '请输入发票号',
  'pages.invoiceList.search.invoiceNumber': '发票号',
  'pages.invoiceList.table.invoiceNumber': '发票号',
  'pages.invoiceList.search.customerInfoType': '客户信息类型',
  'pages.invoiceList.search.customerInfo': '客户信息',
  'pages.invoiceList.search.reset': '重置',
  'pages.invoiceList.search.submit': '查询',
  'pages.invoiceList.search.refresh': '刷新',
  'pages.invoiceList.customerInfo': '客户信息',
  'pages.invoiceList.search.customerInfoType.phone': '电话',
  'pages.invoiceList.search.customerInfoType.name': '姓名',
  'pages.invoiceList.search.customerInfoType.memberId': '会员ID',
  'pages.invoiceList.search.customerInfo.placeholder': '请输入',
  'pages.orderList.title': '发票列表',
  'pages.orderList.orderId': '发票ID',
  'pages.orderList.orderNumber': '发票编号',
  'pages.orderList.invoiceNo': '发票号',
  'pages.orderList.invoiceTime': '开票时间',
  'pages.orderList.customerName': '客户名称',
  'pages.orderList.customerInfo': '用户信息',
  'pages.orderList.customerInfo.phone': '电话',
  'pages.orderList.customerInfo.name': '姓名',
  'pages.orderList.customerInfo.memberId': '会员ID',
  'pages.orderList.totalAmount': '总金额',
  'pages.orderList.orderTime': '发票时间',
  'pages.orderList.createdAt': '创建时间',
  'pages.orderList.status': '状态',
  'pages.orderList.status.pending': '待处理',
  'pages.orderList.status.completed': '已完成',
  'pages.orderList.status.cancelled': '已取消',
  'pages.orderList.status.paid': '已支付',
  'pages.orderList.status.refunded': '退款',
  'pages.orderList.status.partiallyRefunded': '部分退款',
  'pages.orderList.actions': '操作',
  'pages.orderList.actions.view': '查看',
  'pages.orderList.actions.complete': '完成',
  'pages.orderList.actions.cancel': '取消',
  'pages.orderList.actions.details': '明细',
  // Search form
  'pages.orderList.search.orderNumber.placeholder': '请输入发票编号',
  'pages.orderList.search.invoiceNo.placeholder': '请输入发票号',
  'pages.orderList.search.customerInfo.placeholder': '请输入',
  'pages.orderList.search.reset': '重置',
  'pages.orderList.search.submit': '查询',
  'pages.orderList.search.refresh': '刷新',
  // Member List translations
  'pages.memberList.name': '名字',
  'pages.memberList.search.info.placeholder': '请输入',
  'pages.memberList.create': '创建',
  'pages.memberList.title': '会员列表',
  'pages.memberList.memberId': '会员编号',
  'pages.memberList.registerTime': '注册时间',
  'pages.memberList.phone': '联系电话',
  'pages.memberList.email': '邮箱',
  'pages.memberList.points': '当前剩余积分',
  'pages.memberList.actions': '操作',
  'pages.memberList.actions.details': '详情',
  'pages.memberList.status': '状态',
  'pages.memberList.status.active': '激活',
  'pages.memberList.status.inactive': '未激活',
  'pages.memberList.search.memberId.placeholder': '请输入会员ID',
  'pages.memberList.search.info': '用户信息',
  'pages.memberList.search.info.phone': '手机',
  'pages.memberList.search.info.name': '名字',
  'pages.memberList.search.info.memberId': '会员ID',
  'pages.memberList.search.reset': '重置',
  'pages.memberList.search.submit': '查询',
  'pages.memberList.search.refresh': '刷新',
  // Gift Card List translations
  'store.giftCard.list.title': '礼品卡列表',
  'store.giftCard.list.cardId': '礼品卡编号',
  'store.giftCard.list.createTime': '创建时间',
  'store.giftCard.list.phone': '联系电话',
  'store.giftCard.list.search.cardId': '礼品卡编号',
  'store.giftCard.list.search.phone': '手机',
  'store.giftCard.list.search.email': '邮箱',
  'store.giftCard.list.search.status': '状态',
  'store.giftCard.list.search.status.active': '激活',
  'store.giftCard.list.search.status.inactive': '未激活',
  'store.giftCard.list.table.cardId': '礼品卡编号',
  'store.giftCard.list.table.balance': '当前余额',
  'store.giftCard.list.table.status': '状态',
  'store.giftCard.list.table.createTime': '创建时间',
  'store.giftCard.list.table.actions': '操作',
  'store.giftCard.list.table.view': '查看',
  'store.giftCard.list.create': '创建',
  'store.giftCard.list.table.cardNumber': '礼品卡号',
  
  
  'store.giftCard.list.email': '邮箱',
  'store.giftCard.list.balance': '当前余额',
  'store.giftCard.list.actions': '操作',
  'store.giftCard.list.actions.details': '详情',
  'store.giftCard.list.status': '状态',
  'store.giftCard.list.status.active': '激活',
  'store.giftCard.list.status.inactive': '未激活',
  'store.giftCard.list.search.cardId.placeholder': '请输入礼品卡编号',
  'store.giftCard.list.search.info': '临时用户信息',
  'store.giftCard.list.search.info.phone': '手机',
  'store.giftCard.list.search.info.name': '名字',
  'store.giftCard.list.search.info.email': '邮箱',
  'store.giftCard.list.search.reset': '重置',
  'store.giftCard.list.search.submit': '查询',
  'store.giftCard.list.search.refresh': '刷新',
  'store.giftCard.list.card.number': '礼品卡号',
  'store.giftCard.list.action': '操作',
  'store.giftCard.list.detail': '详情',
  // Voucher List translations
  'pages.voucherList.title': '代金券列表',
  'pages.voucherList.voucherId': '代金券编号',
  'pages.voucherList.voucherName': '代金券名称',
  'pages.orderDetails.voucherRedemption': '代金券抵扣',
  'pages.voucherList.startDate': '生效日期',
  'pages.voucherList.createTime': '创建时间',
  'pages.voucherList.phone': '联系电话',
  'pages.voucherList.email': '邮箱',
  'pages.voucherList.amount': '金额',
  'pages.voucherList.minPurchase': '最低消费',
  'pages.voucherList.expiryDate': '有效期至',
  'pages.voucherList.action': '操作',
  'pages.voucherList.actions': '操作',
  'pages.voucherList.detail': '详情',
  'pages.voucherList.actions.details': '详情',
  'pages.voucherList.status': '状态',
  'pages.voucherList.status.active': '激活',
  'pages.voucherList.status.inactive': '未激活',
  'pages.voucherList.status.expired': '已过期',
  'pages.voucherList.status.used': '已使用',
  'pages.voucherList.create': '创建代金券',
  'pages.voucherList.createVirtual': '创建虚拟代金券',
  'pages.voucherList.createPhysical': '创建实体代金券',
  'pages.voucherList.downloadPhysical': '下载实体代金券',
  'pages.voucherList.physicalVoucherNumber': '实体代金券编号',
  'pages.voucherList.voucherNumber': '代金券编号',
  'pages.voucherList.distributionStore': '派发门店',
  'pages.voucherList.contactValue': '联系信息',
  'pages.voucherList.all': '全部',
  'pages.voucherList.noStore': '未找到可访问的门店',
  'pages.voucherList.physical.quantity': '数量',
  'pages.voucherList.physical.batch': '创建批次',
  'pages.voucherList.physical.allBatches': '全部批次',
  'pages.voucherList.physical.loadError': '加载实体代金券表单失败',
  'pages.voucherList.physical.createSuccess': '成功创建 {count} 张实体代金券',
  'pages.voucherList.physical.createError': '创建实体代金券失败',
  'pages.voucherList.physical.batchLoadError': '加载实体代金券批次失败',
  'pages.voucherList.physical.downloadError': '下载实体代金券失败',
  'pages.voucherList.search.voucherId.placeholder': '请输入代金券编号',
  'pages.voucherList.search.info': '临时用户信息',
  'pages.voucherList.search.info.phone': '手机',
  'pages.voucherList.search.info.name': '名字',
  'pages.voucherList.search.info.email': '邮箱',
  'pages.voucherList.search.reset': '重置',
  'pages.voucherList.search.submit': '查询',
  'pages.voucherList.search.refresh': '刷新',
  'pages.voucherList.modal.title': '创建代金券',
  'pages.voucherList.modal.bulkSend': '群发',
  'pages.voucherList.modal.singleSend': '单独发送',
  'pages.voucherList.modal.template': '代金券模板',
  'pages.voucherList.modal.templateName': '模板名称',
  'pages.voucherList.modal.template.placeholder': '请选择代金券模板',
  'pages.voucherList.modal.selectTemplate': '选择代金券模板',
  'pages.voucherList.modal.selectMemberLevel': '选择会员等级',
  'pages.voucherList.modal.memberList': '会员列表',
  'pages.voucherList.modal.memberLevelList': '会员等级列表',
  'pages.voucherList.modal.memberLevelName': '会员等级名称',
  'pages.voucherList.modal.memberCount': '用户数量',
  'pages.voucherList.modal.memberCountText': '{count} 位用户',
  'pages.voucherList.modal.selectMembers': '选择会员',
  'pages.voucherList.modal.selectedCount': '已选择 {count} 位会员',
  'pages.voucherList.modal.searchMember': '搜索会员',
  'pages.voucherList.modal.sendList': '发送列表',
  'pages.voucherList.modal.addToList': '添加',
  'pages.voucherList.modal.removeFromList': '移除',
  'pages.voucherList.modal.submit': '提交',
  'pages.voucherList.modal.cancel': '取消',
  'pages.voucherList.modal.noHeadOffice': '未找到总部信息',
  'pages.voucherList.modal.fetchTemplatesFailed': '获取代金券模板失败',
  'pages.voucherList.modal.fetchMembersFailed': '获取会员列表失败',
  'pages.voucherList.modal.searchFailed': '搜索会员失败',
  'pages.voucherList.modal.alreadyInList': '该会员已在发送列表中',
  'pages.voucherList.modal.addSuccess': '添加成功',
  'pages.voucherList.modal.removeSuccess': '移除成功',
  'pages.voucherList.modal.submitSuccess': '提交成功',
  'pages.voucherList.modal.template.required': '请选择代金券模板',
  'pages.voucherList.modal.memberLevel.required': '请选择会员等级',
  'pages.voucherList.modal.members.required': '请添加要发送的会员',
  'pages.voucherList.modal.creating': '正在创建代金券...',
  'pages.voucherList.modal.createSuccess': '成功创建 {count} 个代金券，CSV文件已下载',
  'pages.voucherList.modal.createFailed': '创建代金券失败',
  'pages.voucherList.modal.emptyList': '暂无数据',
  // Voucher Details
  'pages.store.voucherDetails.title': '折扣券详情页',
  'pages.store.voucherDetails.tempPhone': '临时发送电话',
  'pages.store.voucherDetails.tempEmail': '临时发送邮箱',
  'pages.store.voucherDetails.company': '所属公司',
  'pages.store.voucherDetails.createTime': '创建时间',
  'pages.store.voucherDetails.expireTime': '截至时间',
  'pages.store.voucherDetails.createStore': '创建门店',
  'pages.store.voucherDetails.startTime': '开始时间',
  'pages.store.voucherDetails.Store': '门店',
  'pages.store.voucherDetails.reset': '重置',
  'pages.store.voucherDetails.editInformation': '编辑信息',
  'pages.store.voucherDetails.editStatus': '修改代金券状态',
  'pages.store.voucherDetails.cancel': '取消',
  'pages.store.voucherDetails.ok': '确定',
  'pages.store.voucherDetails.send.phone.label': '手机号码',
  'pages.store.voucherDetails.send.email.label': '邮箱地址',
  'pages.store.voucherDetails.send.phone.placeholder': '请输入手机号码（如：0412345678）',
  'pages.store.voucherDetails.send.email.placeholder': '请输入邮箱地址',
  'pages.store.voucherDetails.send.phone.required': '请输入手机号码',
  'pages.store.voucherDetails.send.email.required': '请输入邮箱地址',
  'pages.store.voucherDetails.send.phone.invalid': '请输入正确的手机号码（04开头10位数字）',
  'pages.store.voucherDetails.send.email.invalid': '请输入正确的邮箱地址',
  'pages.store.voucherDetails.send.sms.success': '短信发送成功',
  'pages.store.voucherDetails.send.sms.failed': '短信发送失败',
  'pages.store.voucherDetails.send.email.success': '邮件发送成功',
  'pages.store.voucherDetails.send.email.failed': '邮件发送失败',
  'pages.store.voucherDetails.delete': '删除',
  'pages.store.voucherDetails.delete.confirm': '确定要删除这个代金券吗？',
  'pages.store.voucherDetails.delete.warning': '删除后无法恢复！',
  'pages.store.voucherDetails.delete.success': '删除成功',
  'pages.store.voucherDetails.delete.failed': '删除失败',
  'pages.store.voucherDetails.enable': '启用',
  'pages.store.voucherDetails.disable': '禁用',
  'pages.store.voucherDetails.status.update.success': '状态更新成功',
  'pages.store.voucherDetails.status.update.failed': '状态更新失败',
  'pages.store.voucherDetails.storeManager': '门店经理',
  'pages.store.voucherDetails.status': '状态',
  'pages.store.voucherDetails.amount': '折扣券面额',
  'pages.store.voucherDetails.consumption.records': '使用记录',
  'pages.store.voucherDetails.consumption.tradeCode': '发票编号',
  'pages.store.voucherDetails.consumption.invoiceDate': '发票日期',
  'pages.store.voucherDetails.consumption.amount': 'Voucher使用金额',
  'pages.store.voucherDetails.consumption.store': '门店',
  'pages.store.voucherDetails.consumption.status': '状态',
  'pages.store.voucherDetails.consumption.tradeCode.placeholder': '请输入发票编号',
  'pages.store.voucherDetails.search': '搜索',
  'pages.store.voucherDetails.send.voucher': '发送折扣券',
  'pages.store.voucherDetails.send.to.phone': '发送到手机',
  'pages.store.voucherDetails.send.to.email': '发送到邮箱',
  'pages.store.voucherDetails.send.success': '发送成功',
  'pages.store.voucherDetails.send.error': '发送失败',
  'pages.store.voucherDetails.balance.modify': '余额修改',
  'pages.store.voucherDetails.balance.amount': '金额',
  'pages.store.voucherDetails.balance.amount.required': '请输入金额',
  'pages.store.voucherDetails.balance.amount.min': '金额必须大于0',
  'pages.store.voucherDetails.balance.reason': '修改原因',
  'pages.store.voucherDetails.balance.reason.required': '请输入修改原因',
  'pages.store.voucherDetails.balance.modify.success': '修改成功',
  'pages.store.voucherDetails.balance.modify.error': '修改失败',
  // Order Details
  'pages.orderDetails.invoiceInfo': '发票信息',
  'pages.orderDetails.invoiceNumber': '发票编号',
  'pages.orderDetails.invoiceNo': '发票编号',
  'pages.orderDetails.status': '状态',
  'pages.orderDetails.invoiceTime': '开票时间',
  'pages.orderDetails.pointsEarned': '本次增加积分',
  'pages.orderDetails.notes': '备注',
  'pages.orderDetails.noNotes': '无',
  'pages.orderDetails.afterTransaction': '消费后',
  'pages.orderDetails.items': '购买商品',
  'pages.orderDetails.productAmount': '本次商品消费',
  'pages.orderDetails.serviceFee': '手续费',
  'pages.orderDetails.memberDiscount': '会员优惠',
  'pages.orderDetails.memberPoints': '会员积分抵扣',
  'pages.orderDetails.giftCard': '礼品卡支付',
  'pages.orderDetails.voucherRedemption': '代金券抵扣',
  'pages.orderDetails.consumption': '商品消费',
  'pages.orderDetails.actualPayment': '实际消费',
  'pages.orderDetails.customer': '客户信息',
  'pages.orderDetails.customerName': '姓名',
  'pages.orderDetails.customerBalance': '积分余额',
  'pages.orderDetails.email': '邮箱',
  'pages.orderDetails.phone': '手机号',
  'pages.orderDetails.viewCustomerDetails': '查看详情',
  'pages.orderDetails.viewCardDetails': '查看详情',
  'pages.orderDetails.viewVoucherDetails': '查看详情',
  'pages.orderDetails.card': '礼品卡信息',
  'pages.orderDetails.cardNumber': '卡号',
  'pages.orderDetails.cardBalance': '余额',
  'pages.orderDetails.voucher': '代金券信息',
  'pages.orderDetails.voucherNumber': '代金券编号',
  'pages.orderDetails.voucherCode': '代金券编号',
  'pages.orderDetails.total': '合计',
  'pages.orderDetails.balanceDescription': '当前余额',
  // Menu items
  'menu.home': '首页',
  'menu.settings': '设置',
  'menu.orders': '发票管理',
  'menu.invoiceList': '发票列表',
  'menu.invoiceDetails': '发票详情',
  'menu.memberList': '会员列表',
  'menu.giftCardList': '礼品卡列表',
  'menu.voucherList': '代金券列表',
  'menu.voucherDetails': '代金券详情',
  'pages.memberDetails.title': '会员详情',
  'pages.memberDetails.phone': '手机号',
  'pages.memberDetails.email': '邮箱',
  'pages.memberDetails.company': '所属公司',
  'pages.memberDetails.registrationTime': '注册时间',
  'pages.memberDetails.lastConsumption': '最近消费',
  'pages.memberDetails.name': '姓名',
  'pages.memberDetails.registrationStore': '注册门店',
  'pages.memberDetails.storeManager': '门店管理',
  'pages.memberDetails.store': '门店',
  'pages.memberDetails.action': '操作',
  'pages.memberDetails.memberId': '会员编号',
  'pages.memberDetails.status.active': '已激活',
  'pages.memberDetails.status.inactive': '未激活',
  'pages.memberDetails.status.normal': '已激活',
  'pages.memberDetails.status.frozen': '未激活',
  'pages.memberDetails.status.deleted': '已删除',
  'pages.store.memberDetails': {
    'edit.success': '编辑成功',
    'edit.fail': '编辑失败',
    'edit.submit':'提交',
    'edit.cancel':'取消',
    'edit.title': '信息编辑',
    'edit.info': '编辑',
    'modify.points': '积分修改',
    'reset.points': '重置积分',
    'reason':'原因',

    'member': '会员',
    'memberId': '会员编号',
    'memberLevel': '会员等级',
    'discount': '折扣',
    'points.modify': '积分修改',
    'send.card': '发送会员卡',
    'send.email': '发送至邮箱',
    'send.phone': '发送至手机',
    'basic.info': '基本信息',
    'consumption.record': '消费记录',
    'points.record': '积分记录',
    'points.reward': '积分奖励',
    'points.reward.modify': '修改积分奖励',
    'points.reward.points': '积分',
    'points.reward.description': '描述',
    'points.redeem': '积分兑换',
    'points.after': '使用后',
    'points.time': '时间',
    'points.change': '积分变更',
    'points.change.before': '变更前',
    'points.change.after': '变更后',
    'points.change.reason': '变更原因',
    'points.change.description': '描述',
    'points.change.submit': '提交',
    'points.type': '类型',
    'points.type.manual': '手动',
    'points.type.transaction': '交易',
    'points.amount': '数量',
    'points.balance': '余额',
    'points.operation': '操作',
    'points.remark': '备注',
    'points.description': '描述',
    'points.change.record': '积分变更记录',
    'invoice.number': '发票编号',
    'invoice.amount': '发票金额',
    'invoice.date': '发票日期',
    'please.enter': '请输入',
    'search': '查询',
    'reset': '重置',
    'status': '状态',
    'points': '积分',
    'member.level': '会员等级',
    'phone': '手机',
    'email': '邮箱',
    'points.change.record': '积分变更记录',
    'invoice.number': '发票编号',
    'invoice.amount': '发票金额',
    'invoice.time': '发票时间',
    'invoice.date': '发票日期',
    'please.enter': '请输入',
    'search': '查询',
    'reset': '重置',
    'status': '状态',
    'points': '积分',
    'member.level': '会员等级',
    'phone': '手机',
    'email': '邮箱',
    'registration.time': '注册时间',
    'last.consumption': '最近消费',
    'name': '姓名',
    'company': '所属公司',
    'registration.store': '注册门店',
    'store.manager': '门店管理',
    'store': '门店',
    'action': '操作',
    'detail': '明细',
    'status.active': '已激活',
    'status.inactive': '未激活',
    'status.pending_payment': '待支付',
    'status.paid': '已支付',
    'status.refunded': '退款',
    'status.partial_refund': '部分退款',
    'total.points': '累计积分',
    'rewardEnabled': '积分奖励',
    'rewardEnabled.on': '已启用',
    'rewardEnabled.off': '已禁用',
  },
  'pages.store.settings': {
    'title': '总部设置',
    'basicInfo': '基本信息',
    'storeName': '门店名称',
    'discountRate': '折扣率%',
    'memberPriceLevel': '会员价格等级',
    'storeName.required': '请输入门店名称',
    'action': '操作',
    'edit': '卡面编辑',
    'delete': '删除',
    'giftCardLevel.add': '添加等级',
    'voucherLevel.add':'添加等级',
    'voucherLevelIndex': '等级',
    'voucherLevelName': '等级名称',
    'defaultBalance': '默认余额',
    'giftCardLevelDefaultBalance': '默认余额',
    'giftCardLevelDefaultBalance.required': '请输入默认余额',
    'giftcardLevelIndex': '等级',
    'giftcardLevelName': '等级名称',
    'voucherLevelDefaultBalance': '默认余额',
    'voucherLevelDefaultBalance.required': '请输入默认余额',
    'pointsPerDollar': '每消费1元获得积分',
    'pointsPerDollar.required': '请输入每消费1元获得积分',
    'dollarsPerPoint': '每1元可抵扣积分',
    'dollarsPerPoint.required': '请输入积分抵扣比例',
    'startDate': '开始日期',
    'startDate.required': '请输入开始日期',
    'expiryDate': '到期日期',
    'expiryDate.required': '请输入到期日期',
    'minPurchase': '最低消费',
    'minPurchase.required': '请输入最低消费',
    'amount': '金额',
    'amount.required': '请输入金额',
    'memberLevels': '会员等级设置',
    'giftCardLevels': '礼品卡等级设置',
    'voucherLevels': '折扣券等级设置',
    'memberLevel.level': '等级',
    'memberLevel.name': '等级名称',
    'memberLevel.discountRate': '折扣率',
    'memberLevel.add': '添加等级',
    'memberLevelIndex': '等级',
    'memberLevelName': '等级名称',
    'memberLevelDiscountRate': '折扣率',
    'save': '保存更改',
    'save.success': '保存成功',
    'save.error': '保存失败',
  },
  'pages.store.statistics': {
    'title': '通讯统计',
    'headOffice': {
      'overview': '总部通讯使用概览',
      'emailQuota': '本月可用邮件总量',
      'emailRemaining': '本月剩余邮件额度',
      'smsQuota': '本月可用短信总量',
      'smsRemaining': '本月剩余短信额度',
      'emailTrend': '邮件月度使用量趋势',
      'smsTrend': '短信月度使用量趋势',
      'historyUsage': '历史使用量统计',
      'selectDateRange': '选择日期范围：',
      'currentYearMonth': '当前年月',
      'last6Months': '最近6个月数据',
      'emailUnit': '封',
      'smsUnit': '条',
      'noData': '暂无数据',
      'loading': '加载中...',
      'downloadExcel': '下载Excel',
      'month': '月份',
      'emailCount': '邮件使用量',
      'smsCount': '短信使用量',
      'emailResourcePackages': '邮件资源包',
      'smsResourcePackages': '短信资源包',
      'totalQuota': '总配额',
      'used': '已使用',
      'remaining': '剩余',
      'expireDate': '到期日期',
      'status': '状态',
      'active': '有效',
      'expired': '已过期',
      'total': '总计',
      'emails': '封邮件',
      'messages': '条短信',
    },
    'store': {
      'usage': '分店使用量统计',
      'name': '分店名称',
      'emailUsage': '本月邮件使用量',
      'smsUsage': '本月短信使用量',
      'action': '操作 (最近6个月)',
      'downloadSms': '下载短信记录',
      'downloadEmail': '下载邮件记录',
      
      'noData': '暂无数据',
    },
    'smsCostCalculator': {
      'title': '短信成本计算器',
      'content': '短信内容',
      'contentPlaceholder': '输入您要发送的短信内容，支持表情符号和换行...',
      'recipients': '发送人数',
      'recipientsPlaceholder': '输入需要发送的人数',
      'calculate': '计算费用',
      'reset': '重置',
      'segmentCount': '分段数量',
      'segments': '段',
      'costPerMessage': '单条费用',
      'totalCost': '总费用',
      'priceDisclaimer': '价格仅供参考，准确价格以联系 POS Supplier 为准',
      'tips': '温馨提示',
      'tip1': '• 包含中文、表情符号会增加分段数量',
      'tip2': '• 纯英文：160字符/条，超出后按153字符分段',
      'tip3': '• 含中文/表情：70字符/条，超出后按67字符分段',
      'tip4': '• 单条短信价格：$0.18 AUD',
    },
  },
  'pages.store.memberDetails.record.date': '记录日期',
  'pages.store.giftCardDetails': {
    'giftCard': '储值卡',
    'card.number': '储值卡号',
    'balance': '余额',
    'register.time': '创建时间',
    'valid.days': '有效期（天）',
    'active.time': '激活时间',
    'expiry.time': '到期时间',
    'balance.record': '余额变更记录',
    'balance.after': '使用后',
    'invoice.number': '发票编号',
    'giftCard.number': '储值卡号',
    'temp.phone': '临时发送电话',
    'temp.email': '临时发送邮箱',
    'company': '所属公司',
    'registration.time': '创建时间',
    'registration.store': '创建门店',
    'store.manager': '门店管理',
    'status': '状态',
    'time': '时间',
    'amount': '金额',
    'type': '类型',
    'type.consume': '消费',
    'type.activation': '激活',
    'type.refund': '退款',
    'type.manual': '手动',
    'description': '描述',
    'balance': '剩余余额',
    'consumption.record': '消费记录',
    'balance.change.record': '余额变更记录',
    'invoice.number': '交易编号',
    'invoice.date': '交易日期',
    'please.enter': '请输入',
    'search': '查询',
    'reset': '重置',
    'store': '门店',
    'action': '操作',
    'detail': '明细',
    'status.active': '激活',
    'status.inactive': '已禁用',
    'status.expired': '已过期',
    'balance.modify': '余额修改',
    'edit.info': '信息编辑',
    'status.pending_payment': '待付款',
    'status.partial_refund': '部分退款',
    'status.paid': '已支付',
    'status.refunded': '退款',
    'balanceChangeRecords': '余额变更记录',
    'consumptionRecords': '消费记录',
    'changeTime': '变更时间',
    'changeAmount': '变更金额',
    'operation': '操作',
    'operator': '操作人',
    'selectDate': '选择日期',
    'search': '查询',
    'reset': '重置',
    'consumption.record': '消费记录',
    'invoice.number': '发票编号',
    'invoice.amount': '礼品卡使用金额',
    'invoice.date': '发票日期',
    'please.enter': '请输入',
    'balance.change.record': '余额变更记录',
    'changeTime': '变更时间',
    'changeAmount': '变更金额',
    'operation': '操作',
    'operator': '操作人',
    'selectDate': '选择日期',
    'operation.type.recharge': '充值',
    'operation.type.consumption': '消费',
    'operation.type.change': '变更',
    'operation.source.store': '门店',
    'operation.source.website': '网站',
    'send.giftcard': '发送礼品卡',
    'send.to.phone': '发送到手机',
    'send.to.email': '发送到邮箱',
    'send.success': '发送成功',
    'send.error': '发送失败',
    'balance.modify': '余额修改',
    'reset.balance': '重置余额',
    'reason': '原因',
    'balance.amount': '金额',
    'balance.amount.required': '请输入金额',
    'balance.amount.min': '金额必须大于0',
    'balance.reason': '修改原因',
    'balance.reason.required': '请输入修改原因',
    'balance.modify.success': '修改成功',
    'balance.modify.error': '修改失败',
  },
  'pages.actions': {
    'create': '新建',
    'edit': '编辑',
    'delete': '删除',
    'view': '查看',
    'search': '搜索',
    'reset': '重置',
    'submit': '提交',
    'cancel': '取消',
    'confirm': '确认',
  },
  'pages.actions.operation': '操作',
  'pages.actions.save': '保存',
  'permissions.fetchFailed': '获取权限数据失败',
  'pages.store.physicalCard': {
    'title': '实体会员卡',
    'download': '下载实体会员卡',
    'description': '请先联系POS供应商获取会员卡资源。',
    'usage': '点击下载按钮可以获取所有未激活的实体卡的Online Member ID列表，格式为CSV文件。文件将包含所有未激活实体卡的在线会员编号。',
    'downloadSuccess': '实体会员卡文件下载成功',
    'downloadError': '下载实体会员卡失败',
    'noPermission': '您没有下载权限',
    'noDataFound': '未找到未激活的实体卡',
  },
  'pages.store.customerExport': {
    'title': '导出用户',
    'download': '导出用户',
    'description': '导出所选时间范围内在客户历史记录中有过记录的用户。',
    'timeRange': '时间范围',
    'status': '状态',
    'statusActive': '活跃',
    'statusAll': '全部',
    'memberLevel': '会员等级',
    'allMemberLevels': '全部会员等级',
    'oneMonth': '最近1个月',
    'threeMonths': '最近3个月',
    'sixMonths': '最近半年',
    'twelveMonths': '最近1年',
    'success': '用户列表导出成功',
    'error': '用户列表导出失败',
    'noPermission': '您没有导出权限',
  },
  'pages.store.otherSettings': {
    'title': '其他设置',
    'customerRegisterEmailRequired': '客户注册邮箱必填',
    'customerRegisterEmailRequired.description': '启用后，客户注册时必须提供邮箱地址',
    'save.success': '设置保存成功',
    'save.error': '设置保存失败',
  },
  'pages.pointsAudit.title': '积分审查',
  'pages.pointsAudit.dateRange': '日期范围',
  'pages.pointsAudit.get': '获取',
  'pages.pointsAudit.time': '时间',
  'pages.pointsAudit.member': '会员',
  'pages.pointsAudit.currentPoints': '会员当前积分',
  'pages.pointsAudit.pointsChange': '修改积分',
  'pages.pointsAudit.operator': '操作人员',
  'pages.pointsAudit.actions': '操作',
  'pages.pointsAudit.details': '详情',
  'pages.pointsAudit.total': '共 {total} 条',
  'pages.pointsAudit.loadFailed': '获取积分审查记录失败',
  'pages.pointsAudit.dateRequired': '请选择日期范围',
};
